import React, { useEffect, useState } from "react";
import "./Signin.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { currentUser, login } from "../../Redux/Auth/Action";
import { FaUser, FaLock } from "react-icons/fa";

const Signin = () => {
  const navigate = useNavigate();
  const [inputData, setInputData] = useState({ username: "", password: "" });
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const { auth } = useSelector((store) => store);
  const [errorMessage, setErrorMessage] = useState("");

  const handelSubmit = (e) => {
    setErrorMessage("");
    e.preventDefault();
    dispatch(login(inputData))
      .then((response) => {
        if (response.token) {
          navigate("/");
        } else {
          setErrorMessage("Invalid credentials");
          setTimeout(() => {
            setErrorMessage("");
          }, 3000);
        }
      })
      .catch((e) => {
        setErrorMessage("Invalid credentials. Please try again.");
        setTimeout(() => {
        setErrorMessage("");
        }, 3000);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData((values) => ({ ...values, [name]: value }));
  };
  useEffect(() => {
    if (token) dispatch(currentUser(token));
  }, [token, dispatch]);

  useEffect(() => {
    if (auth.reqUser?.username) {
      navigate("/");
    }
  }, [auth.reqUser, navigate]);

  return (
    <div>
      <div className="login">
        <div className="container-fluid px-1 px-md-5 px-lg-1 px-xl-5 py-3 mx-auto">
          <div className="card-login">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 p-2 mt-5 image-container">
                <img
                  width="100%"
                  height="100%"
                  src="./images/login-bg.jpg"
                  alt="login"
                />
              </div>

              <div className="col-lg-1 d-none d-lg-block">
                {/* <img src="./images/vedtslogo.jpg" alt="profile-image" className='mt-5'/> */}
              </div>

              <div className="col-lg-5 col-md-6 col-sm-12 mt-5">
                <form onSubmit={handelSubmit}>
                  <div className="form-group">
                    <div className="card-logo p-4">
                      <div className="form-logo">
                        <img
                          src="./images/Hrms.jpg"
                          alt="profile-image"
                          className="image"
                        />
                      </div>
                      {errorMessage && (
                        <div className="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}
                      <div className="mb-3 input-group">
                        <span className="input-group-text">
                          <FaUser />
                        </span>
                        <input
                          name="username"
                          type="text"
                          className="form-control"
                          placeholder="Enter your Username"
                          value={inputData.email}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="mb-3 input-group">
                        <span className="input-group-text">
                          <FaLock />
                        </span>
                        <input
                          name="password"
                          type="password"
                          className="form-control"
                          placeholder="Enter your Password"
                          value={inputData.password}
                          onChange={handleChange}
                        />
                      </div>
                      <button type="submit" className="btn btn-primary btn-sm">
                        Signin
                      </button>
                    </div>
                    <div className="">
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={() => navigate("/forgotPassword")}
                      >
                        Forgot Password
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-column">
            <h3 className="footer-title">About Us</h3>
            <p className="footer-text">
              We are committed to providing the best services to our customers.
              Learn more about our journey and values.
            </p>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <a href="/#">Home</a>
              </li>
              <li>
                <a href="/#">Services</a>
              </li>
              <li>
                <a href="/#">About</a>
              </li>
              <li>
                <a href="/#">Contact</a>
              </li>
              <li>
                <a href="/#">Blog</a>
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Contact Us</h3>
            <ul className="footer-contact">
              <li>
                <span>Phone:</span> <a href="tel:+91 7676621612">7676621612</a>
              </li>
              <li>
                <span>Email:</span>{" "}
                <a href="mailto:info@elexyt.com">info@elexyt.com</a>
              </li>
              <li>
                <span>Address:</span> Bangalore, Karnataka
              </li>
            </ul>
          </div>
          <div className="footer-column">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-social">
              <a href="https://www.elexyt.com/" className="footer-social-link">
                <img src="./images/facebook.png" alt="fb"></img>
              </a>
              <a
                href="https://www.linkedin.com/company/elexyt?trk=organization_guest_main-feed-card_feed-article-content"
                className="footer-social-link"
              >
                <img src="./images/linked-in.png" alt="fb"></img>
              </a>
              <a href="https://www.elexyt.com/" className="footer-social-link">
                <img src="./images/twitter.png" alt="fb"></img>
              </a>
              <a href="https://www.elexyt.com/" className="footer-social-link">
                <img src="./images/instagram.png" alt="fb"></img>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            &copy; 2024 Developed By: Elexyt PVT. LTD. | All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Signin;
